'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { ARCHIVED_AND_UNPUBLISHED_CONTENT } from '../actions/ActionTypes';
import { receiveContent, requestArchiveAndUnpublishContent, requestContent, requestedArchiveAndUnpublishContentFailure, requestedArchiveAndUnpublishContentSuccess, requestedContentFailed } from '../actions/ContentActions';
import { closeModal } from '../actions/ModalActions';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(ARCHIVED_AND_UNPUBLISHED_CONTENT).pipe(mergeMap(({
  payload: {
    contentPageId,
    contentType
  }
}) => ContentClient.archiveAndUnpublishContent(contentType, contentPageId).pipe(mergeMap(response => {
  if (response.status === 'error' && response.errorType && response.errors && response.errors.length > 0) {
    return of(requestedArchiveAndUnpublishContentFailure({
      responseJSON: response.errors[0]
    }, contentType));
  }
  return ContentClient.fetchContent({
    contentPageId,
    contentType
  }).pipe(mergeMap(content => of(receiveContent(content), closeModal(), requestedArchiveAndUnpublishContentSuccess(contentType))), catchError(error => of(requestedContentFailed(error))), startWith(requestContent()));
}), catchError(error => of(requestedArchiveAndUnpublishContentFailure(error, contentType))), startWith(requestArchiveAndUnpublishContent())))));